import React, { useState } from 'react';

import './Programs.scss';
import { useQuery } from '@apollo/client';
import gqlSchemaLibrary from '../services/graphql.schemas';

import ButtonIcon from '../forms/buttons/Button.icon';
import {Link, useNavigate, useParams} from 'react-router-dom';
import ProgramsBaseEnrolled from './Programs.enrolled';
import SpinnerLoader from "../visuals/SpinnerLoader";
import {ModalProgramCreate} from "../visuals/ModalProgramCreate";
import ItemMenu from "../forms/menu/MenuComponent";
import {useTranslation} from "react-i18next";
import {PageViewLog} from "../services/interactions/page.view";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";

function ProgramsBase({ currentOrg, match, currentUser, toaster, params }) {
    let {programId} = useParams();
    const {t} = useTranslation(['programs']);
    const [patientByProgram, setPatientByProgram] = useState([]);
    const [programOptions, setProgramOptions] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const [openProgramCreate, setOpenProgramCreate] = useState(false);
    const navigate = useNavigate();

    useQuery(gqlSchemaLibrary.programs.query.getCurrentOrgPrograms, {
        onCompleted: (onPrograms) => {
            if (onPrograms.getCurrentOrgPrograms) {
                setProgramOptions(onPrograms.getCurrentOrgPrograms);
                for (const program of onPrograms.getCurrentOrgPrograms) {
                    console.log('Getting by program: ', program._id);
                }
                if(programId){
                    if(!onPrograms.getCurrentOrgPrograms.some(oP => oP._id === programId)){
                        navigate(-1);
                    }
                }
            }
            setLoadData(false);
        },
        fetchPolicy: 'cache-and-network'
    })

    useQuery(gqlSchemaLibrary.patients.countPersonInProgram, {
        onCompleted: (onPatients) => {
            if (!!onPatients.countPersonInProgram.length) {
                setPatientByProgram(onPatients.countPersonInProgram);
            }
        },
        fetchPolicy: 'cache-and-network'
    })

    const vitalAcronym = (value) => {
        if (value === 'SPO2') { return 'O2' }
        if (value === 'Temp') { return 'T' }
        if (value === 'Position') { return 'P' }
        if (value === 'Activity') { return 'A' }
        if (value === 'Sleep') { return 'S' }
        return value;
    }

    const renderProgramEnrolled = () => {
        return <ProgramsBaseEnrolled currentOrg={currentOrg} match={match} program={programOptions.find(po => po._id === programId)} currentUser={currentUser} toaster={toaster} params={params} />
    }

    const closeModal = (onAction, template) => {
        setOpenProgramCreate(false);
        if (onAction) {
            let templateID = '';
            if (template && template.id !== 0) {
                templateID = template.id;
            }
            navigate('/programs/create/'+templateID);
        }
    }

    const newProgram = () => {
        setOpenProgramCreate(true);
    }

    const goToEditProgram = (program) => {
        return () => {
            AuditTrail.sendLog(PAGES.PROGRAM_LIST, {tag: 'button', event: 'onClick', action: 'button open edit program', program_id: program._id});
            navigate(`/programs/edit/${program._id}`)
        }
    }

    const createProgram = () => {
        return currentUser.userRoles && currentUser.userRoles.programsBase.create;
    }

    const editProgram = () => {
        return currentUser.userRoles && currentUser.userRoles.programsBase.edit;
    }

    const openDetail = (program) => {
        AuditTrail.sendLog(PAGES.PROGRAM_LIST, {tag: 'button', event: 'onClick', action: 'button open detail program', program_id: program._id});
        navigate(`/programs/detail/${program._id}`)
    }

    const renderProgramSelection = () => {
        return (
            <div id="ProgramsBase">
                <div className="filter">
                    <div className="programOptions">
                    </div>
                    <div className={`programFilters ${createProgram() ? '' : '_col2'}`}>
                        <div className="searchFilters">

                        </div>
                        <p className="_counter">
                            {programOptions.length} {programOptions.length === 1 ? 'program' : 'programs'}
                         </p>
                        {
                            createProgram() ?
                                <div className="enrollAction" onClick={newProgram}>
                                    <ButtonIcon>
                                        <span className="material-icons">
                                            add
                                    </span>
                                    </ButtonIcon>
                                    <p>{t('new-program')}</p>
                                </div> : ''
                        }
                    </div>
                </div>
                <div className="programList">
                    {programOptions.map(program => {
                        const patientsByProgram = patientByProgram.find(pbp => pbp.program === program._id);
                        return (
                            <div className="program" key={program._id}>
                                <div className="programTitle">
                                    <h3 onClick={() => openDetail(program)}>{program.name}</h3>
                                    {
                                        editProgram() && (!!patientsByProgram ? patientsByProgram.count : 0) === 0 ?
                                            <ItemMenu actionWillRedirect={false}>
                                                <>
                                                    <div className="_option" onClick={goToEditProgram(program)}>
                                                        <p>Edit program</p>
                                                    </div>
                                                </>
                                            </ItemMenu> : ''
                                    }
                                    <button>
                                        <i className="material-icons hidden">
                                            more_vert
                                    </i>
                                    </button>
                                    <div className="_details">
                                        <p></p>
                                        <p></p>
                                    </div>
                                </div>
                                <div className="programVitals">
                                    <div className="vitalList">
                                        {program.vitals.filter((_, i) => i < 5).map((v) => (
                                            <div className={`_vital _${v.value}`} key={v.value}>
                                                <span>
                                                    {vitalAcronym(v.value)}
                                                </span>
                                            </div>
                                        ))}
                                        {
                                            program.vitals.length > 5 ?
                                                <span className="_more">+{program.vitals.length - 5}</span>
                                                : ''
                                        }
                                    </div>
                                    <div className="status">
                                        <p className="_active">Active</p>
                                        <Link to={`/programs/${program._id}/participants`}>
                                            <p className="_participants"><span>{!!patientsByProgram? patientsByProgram.count : 0}</span> participant{patientsByProgram && patientsByProgram.count === 1? '': 's'}</p>
                                        </Link>
                                        <p></p>
                                        <Link to={`/programs/${program._id}/users`}>
                                            <p className="_participants"><span>{program.users.length}</span> user{program.users.length === 1? '': 's'}</p>
                                        </Link>
                                        <p></p>
                                        <Link to={`/programs/${program._id}/teams`}>
                                            <p className="_participants"><span>{program.teams.length}</span> team{program.teams.length === 1? '': 's'}</p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    {
                        createProgram()?
                            <div className="program" onClick={newProgram}>
                                <div className="programAdd">
                                    <i className="material-icons">add</i>
                                    <h3>{t('new-program')}</h3>
                                </div>
                            </div> : ''
                    }
                </div>
                { <ModalProgramCreate openModal={openProgramCreate} closeModal={closeModal} /> }
                { loadData? <SpinnerLoader/>: '' }
            </div>
        )
    }
    if (programId) {
        return (renderProgramEnrolled())
    } else {
        return (renderProgramSelection())
    }
}

export default PageViewLog(ProgramsBase);
